import React from 'react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    className?: string;
}

export const Select: React.FC<SelectProps> = ({ className = '', children, ...props }) => {
    return (
        <select
            className={`w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder-gray-400 
        focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent 
        disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
            {...props}
        >
            {children}
        </select>
    );
}; 